import Select from 'react-select'

const NewInfoSelector = ({ value, setValue, options, category, noOptionsMessage = undefined, isMulti = false }) => (
    <Select
        options={options}
        value={value}
        onChange={setValue}
        isMulti={isMulti}
        noOptionsMessage={() => noOptionsMessage ? noOptionsMessage : `Please create at least one ${category} before exporting a service`}
    />
)

export default NewInfoSelector